let auth;

window.addEventListener('load', async () => {

    auth = await auth0.createAuth0Client({
        domain: 'dev-k0l1zx5k8t3xealp.eu.auth0.com',
        clientId: 'bTRi7hHCnmDe6I61tYRz3dZPyVjxx63A',
        authorizationParams: {
            redirect_uri: 'https://bd-rowa.myshopify.com/account',
            connection: 'rowab2cprod'
        }
    })
    //if you do this, you'll need to check the session yourself
//   try {
//     await auth.getTokenSilently();
//   } catch (error) {
//     if (error.error !== 'login_required') {
//       throw error;
//     }
//   }

    const redirectResult = await auth.handleRedirectCallback();
    //logged in. you can get the user profile like this:
    const user = await auth.getUser();

});
document.addEventListener('DOMContentLoaded', async () => {
    document.getElementById('login').addEventListener('click', async () => {
        await auth.loginWithRedirect()
    });
});